import {
  Button,
  ButtonGroup,
} from "@mui/material";
import { useCompanyDocumentsLanguage } from "../i18n/CompanyDocumentsLanguageContext";

export default function CompanyDocumentsLanguageToggle() {
  const {
    language,
    setLanguage,
    t,
  } = useCompanyDocumentsLanguage();

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-[#5F737F]">
        {t("language.label")}
      </span>

      <ButtonGroup
        size="small"
        aria-label={t("language.control")}
      >
        <Button
          aria-pressed={language === "id"}
          variant={
            language === "id"
              ? "contained"
              : "outlined"
          }
          onClick={() =>
            setLanguage("id")
          }
        >
          {t("language.id")}
        </Button>

        <Button
          aria-pressed={language === "en"}
          variant={
            language === "en"
              ? "contained"
              : "outlined"
          }
          onClick={() =>
            setLanguage("en")
          }
        >
          {t("language.en")}
        </Button>
      </ButtonGroup>
    </div>
  );
}
